<p-toast position="top-center" life="3000"></p-toast>

<p-panel
  styleClass="stock-area-filter-panel"
  [toggleable]="true"
  toggler="header"
  [(collapsed)]="filterPanelCollapsed">
  <ng-template #header>
    <div class="filter-panel-header">
      <i [ngClass]="filterPanelCollapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"></i>
      <span>Filters</span>
    </div>
  </ng-template>

  <div class="filter-panel-content">
    <div class="filter-control-grid">
      <p-select
        [options]="filterOptions.site"
        [(ngModel)]="filter.site"
        optionLabel="label"
        optionValue="value"
        placeholder="Sites"
        [filter]="true"
        [showClear]="true"
        styleClass="stock-area-filter-select">
      </p-select>

      <p-select
        [options]="filterOptions.CDA"
        [(ngModel)]="filter.CDA"
        optionLabel="label"
        optionValue="value"
        placeholder="Custom diversion areas"
        [filter]="true"
        [showClear]="true"
        styleClass="stock-area-filter-select">
      </p-select>


      <p-select
        [options]="filterOptions.stockArea"
        [(ngModel)]="filter.stockArea"
        optionLabel="label"
        optionValue="value"
        placeholder="Stock Areas"
        [filter]="true"
        [showClear]="true"
        styleClass="stock-area-filter-select">
      </p-select>

      <div *ngIf="assayManagementEnabled" class="assay-filter-control">
        <p-checkbox
          inputId="assayTrackingFilter"
          [(ngModel)]="filter.assayTrackable"
          [binary]="true">
        </p-checkbox>
        <label for="assayTrackingFilter">Assay tracking</label>
      </div>
    </div>

    <div class="filter-panel-actions">
      <button type="button" class="filter-link-button" (click)="resetFilters()">Reset</button>
      <p-button label="Apply" severity="info" size="small" [outlined]="true" (click)="applyFilters()"></p-button>
    </div>
  </div>
</p-panel>

<p-panel
  styleClass="stock-area-info-panel"
  [toggleable]="true"
  [(collapsed)]="infoPanelCollapsed">
  <ng-template #header>
    <div class="stock-area-info-header">
      <span class="stock-area-info-icon">
        <i class="pi pi-info"></i>
      </span>
      <span class="stock-area-info-title">
        Use stock area configuration to enhance your diversion analytics
      </span>
    </div>
  </ng-template>

  <ng-template #headericons let-collapsed>
    <span class="learn-more-toggle">{{ collapsed ? 'Learn More' : 'Show Less' }}</span>
  </ng-template>
  <ng-container *ngIf="assayManagementEnabled">
    <h4>Waste Assay Tracking:</h4>
    <p>
    When waste assay tracking is enabled for a stock area, eligible waste transactions from that stock area are sent to Assay Management. Hospitals can use Assay Management to track and manage testing of controlled substance waste. To specify which item groups are included in assay workflows, configure them on the Monitored Items page.
    </p>
  </ng-container>
  <h4>Custom Diversion Area:</h4>
  <p>
    A user-defined grouping of cabinet devices used specifically for diversion surveillance. It is separate from, and may differ from, the default Area assigned to a stock area or device in OmniCenter or OmniSphere. Custom Diversion Areas allow devices to be grouped in a way that better supports diversion analytics, rather than relying on the operational area structure used in OmniCenter or OmniSphere.
  </p>
  <h4>Custom Diversion Areas are typically created during implementation to support:</h4>
  <ul>
    <li>Sample Size Optimization: Grouping devices together can increase the number of healthcare workers, transactions, or comparable activity included in the analysis, making statistical scoring more reliable and meaningful.</li>
    <li>Workflow Alignment: Grouping devices with similar medication handling workflows can make peer analytics scores more relevant, accurate, and actionable.</li>
  </ul>
</p-panel>

<div class="stock-area-table-container">
  <p-table
    [value]="records"
    [paginator]="true"
    [rows]="15"
    [showFirstLastIcon]="true"
    [tableStyle]="{ 'min-width': '72rem' }">
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="cols.length" class="empty-message">No stock areas found.</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" scope="col">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
      <tr>
        <td *ngFor="let col of cols">
          @if (col.field === 'assayTrackable') {
            <div tabindex="0"
              class="assay-trackable-toggle"
              [class.assay-trackable-toggle-disabled]="!canEdit()"
              role="button"
              [attr.aria-disabled]="!canEdit()"
              [attr.tabindex]="canEdit() ? 0 : -1"
              (click)="requestAssayTrackableChange(rowData)"
              (keydown.enter)="requestAssayTrackableChange(rowData)"
              (keydown.space)="requestAssayTrackableChange(rowData); $event.preventDefault()">
              <p-toggleSwitch
                size="small"
                [ngModel]="rowData.assayTrackable"
                [readonly]="true"
                [disabled]="!canEdit()"
                ariaLabel="Assay Trackable">
              </p-toggleSwitch>
            </div>
          } @else if (col.field === 'complianceTimeWindow') {
            @if (canEdit()) {
                <p-select
                  styleClass="compliance-window-select"
                  panelStyleClass="compliance-window-panel"
                  [options]="complianceWindowOptions"
                  [ngModel]="rowData.complianceTimeWindow"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="2 Hours"
                  [disabled]="isSavingComplianceWindowChange"
                  (onChange)="onComplianceWindowChange(rowData, $event.value)">
                </p-select>
            } @else {
              {{ rowData.complianceTimeWindow }} Hours
            }
          } @else if (col.field === 'updatedAt') {
              <div class="updated-at-cell">
                @if (rowData.updatedBy) {
                  <span class="updated-by">{{ rowData.updatedBy }}</span>
                }
                <span>{{ rowData.updatedAt | date: 'MM/dd/yyyy hh:mm' }}</span>
              </div>
          } @else {
            {{ rowData[col.field] }}
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  *ngIf="assayManagementEnabled"
  [header]="pendingAssayTrackableValue ? 'Enable assay tracking?' : 'Disable assay tracking?'"
  [(visible)]="showTrackableConfirmDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="stock-area-confirm-dialog">
  <p class="confirm-message">
    {{ pendingAssayTrackableValue
      ? 'Waste transactions from this stock area will now be sent to Assay Management. This cabinet will be tracked for assay retrieval or testing workflows.'
      : 'Waste transactions from this stock area will no longer be sent to Assay Management. This cabinet will not be tracked for assay retrieval or testing workflows.' }}
  </p>

  <ng-template pTemplate="footer">
    <p-button
      label="No"
      severity="secondary"
      variant="text"
      [disabled]="isSavingTrackableChange"
      (click)="cancelTrackableChange()">
    </p-button>
    <p-button
      label="Yes"
      severity="info"
      [loading]="isSavingTrackableChange"
      (click)="confirmTrackableChange()">
    </p-button>
  </ng-template>
</p-dialog>
